import React, {useEffect} from 'react'
import config from 'config'
import {withRouter} from 'react-router-dom'

const LinkGenerator = (props) => {
    const {id} = props.match.params;

    useEffect(() => {
        getDecipherLink()
    }, [])

    const getDecipherLink = () => {
        let requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };
        fetch(`${config.REV_URL}/decipher-link/${id}`, requestOptions)
            .then(res => res.json())
            .then((data) => {
                const resData = data;
                if (resData.success === true) {
                    if (resData.data.originalUrl !== '') {
                        props.history.push(`/${resData.data.originalUrl}`)
                    }
                }
            })
            .catch(error => console.log('error'));
    }

    return (<div></div>)
}

export default withRouter(LinkGenerator)


// WEBPACK FOOTER //
// ./src/components/LinkGenerator.js